import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PurchasePopup from "../../common/PurchasePopup";
import VMModal from "../../common/VMModal";
import { allCoursesStored } from "../../utilities";
import { addToStorage } from "../../utilities/localStorage";
import { cartItems } from "../../redux/constants/courseConstants";
import { useDispatch } from "react-redux";
import { setCartCount, setCartItems } from "../../redux/reducers/courseSlice";

export default function PurchaseOption2({
  to = "",
  enrollto = "",
  isPurchase = false,
  isEnroll = false,
  amount = 0,
  discount = 0,
  original = 0,
  enrollamount = 0,
  enrolloriginal = 0,
}) {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const dispatch = useDispatch();
  const addAllToCart = () => {
    const selectedCourses = allCoursesStored.filter(course => !course.courseCombo.length && course.price > 0);
    addToStorage(cartItems, JSON.stringify(selectedCourses));
    dispatch(setCartCount(selectedCourses.length));
    dispatch(setCartItems(selectedCourses));
    history.push('/cartitems');
  }

  useEffect(
    () => {
      window.scrollTo(0, 0);
      let mobile = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());
      if (mobile) {
        setShow(true);
      } else {
        setShow(false);
      }
    },
    [show],
  );
  return (
    <div className="d-flex flex-row flex-wrap mb-2">
      {isEnroll && (
        <Link to={enrollto} style={{ cursor: "pointer" }} className="text-center btn btn-primary w-100">
          <i className="fa fa-laptop" /> {show ? "ENROLL NOW " : "ENROLL NOW "} (Rs.{enrollamount.toLocaleString('en-IN')}/-){" "}
          <sub>
            <del>{enrolloriginal}</del>
          </sub>
        </Link>
      )}
      &nbsp;&nbsp;
      {isPurchase && (
        <div
          onClick={() => {
            addAllToCart();
            // history.push(to)
          }} style={{ cursor: "pointer" }} className="text-center btn btn-primary w-100">
          <i className="fa fa-shopping-cart" /> BUY NOW (Rs.{(amount ? amount : parseInt(original - ((original / 100) * discount))).toLocaleString('en-IN')}/-){" "}
          <sub>
            <del>{parseInt(original).toLocaleString('en-IN')}</del>
          </sub>
        </div>
      )}

      {showPayment && <VMModal proceed={false} size="lg" title="Payment and Confirm Order" component={<PurchasePopup course={to.split("/purchase/")[1]} onClose={setShowPayment} />} onClose={setShowPayment} />}
    </div>
  );
}
